import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Avatar,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, firestore } from "../../../firebase.js";
import logo from "../../../OV-WarrantyMS.png";

function ShopNavBar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const { displayName, email } = user;
        setUserData({ displayName, email });

        const userProfileRef = doc(firestore, "UserProfileMaster", user.uid);
        const userProfileSnap = await getDoc(userProfileRef);

        if (userProfileSnap.exists()) {
          userProfileSnap.data();
        }
      } else {
        setUserData(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        setUserData(null);
        navigate("/");
        handleMenuClose();
      })
      .catch((error) => {
        console.error("Error signing out: ", error);
      });
  };

  const handlePastComplaint = () => {
    navigate("/complaints_list");
  };

  const handleTitleClick = () => {
    // Always redirect to home page
    navigate("/");
  };

  const handleWarrantyListNavigation = () => {
    navigate("/warranty_list");
  };

  return (
    <div>
      <AppBar position="fixed">
        {/* --- MODIFIED: Removed conditional "center" --- */}
        <Toolbar style={{ justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Typography
              variant="h6"
              onClick={handleTitleClick}
              sx={{
                fontFamily: "'Unbounded', cursive",
                fontWeight: 900,
                color: '#fff',
                fontSize: '1.1rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                lineHeight: 1,
                cursor: "pointer",
              }}
            >
              Aalay<span style={{ color: '#f59e0b', fontSize: '1.4rem' }}>.</span>
            </Typography>

            <Typography
              variant="caption"
              component="div"
              sx={{
                fontStyle: 'italic',
                color: '#fff',
                opacity: 0.85,
                fontSize: '0.7rem',
                mt: 0.2,
                fontFamily: 'inherit',
                textTransform: 'none',
              }}
            >
              Intelligent Operations by OmneVu.com
            </Typography>
          </div>

          {userData && (
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* Conditionally show the Shop Page button for "seller" role */}
              {!isMobile && (
                <Button
                  color="inherit"
                  onClick={handleWarrantyListNavigation}
                  style={{
                    marginRight: "20px",
                    padding: "8px 16px",
                    backgroundColor: "#004ba0",
                    color: "#fff",
                    borderRadius: "8px",
                    border: "2px solid white",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    fontWeight: "bold",
                    textTransform: "none",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#2694d4")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#004ba0")
                  }
                >
                  Warranty Management
                </Button>
              )}

              {/* Avatar for desktop view */}
              {!isMobile && (
                <Tooltip title="Account settings">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
                      <Avatar>{userData.displayName?.charAt(0)}</Avatar>
                    </IconButton>
                    <Typography
                      variant="caption"
                      sx={{ lineHeight: 1, marginTop: "-4px" }}
                    >
                      Warranty
                    </Typography>
                  </div>
                </Tooltip>
              )}

              {/* Hamburger menu for mobile view */}
              {isMobile && (
                <Tooltip title="Open settings">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
                      <MenuIcon sx={{ color: "#fff" }} />{" "}
                      {/* White hamburger icon */}
                    </IconButton>
                    <Typography
                      variant="caption"
                      sx={{ color: "#fff", lineHeight: 1, marginTop: "-4px" }}
                    >
                      Warranty
                    </Typography>
                  </div>
                </Tooltip>
              )}

              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem disabled>
                  <Typography textAlign="center">
                    User: {userData.displayName || userData.email}
                  </Typography>
                </MenuItem>

                {/* Conditionally show Shop Page inside the menu in mobile view */}
                {isMobile && (
                  <MenuItem onClick={handleWarrantyListNavigation}>
                    Warranty Management
                  </MenuItem>
                )}

                {/* --- CORRECTED: Removed typo --- */}
                <MenuItem onClick={handlePastComplaint}>
                  Past Complaints
                </MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>

      <div style={{ marginTop: "64px" }}></div>
    </div>
  );
}

export default ShopNavBar;
